export const enum Keys {
    SHIFT = 'Shift',
    Z = 'z',
    Q = 'q',
    M = 'm',
    C = 'c',
    H = 'h',
    A = 'a',
}

export const enum KeyCodes {
    SPACE = 'Space',
}

interface IKeyCalls {
    [key: string]: (key: string) => void;
}

interface ICodeCalls {
    [key: string]: () => void;
}

export class GameKeys {
    public static isShiftPressed: boolean = false;
    public static isSpacePressed: boolean = false;

    public static init() {
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
        window.addEventListener('keyup', this.handleKeyUp.bind(this));
    }

    public static cleanUp() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
    }

    public static addToKeyCalls(key: string, call: (key: string) => void) {
        GameKeys.keyCalls[key] = call;
    }

    public static removeFromKeyCalls(key: string) {
        delete GameKeys.keyCalls[key];
    }

    public static addToCodeCalls(key: string, call: () => void) {
        GameKeys.codeCalls[key] = call;
    }

    public static removeFromCodeCalls(key: string) {
        delete GameKeys.codeCalls[key];
    }

    private static keyCalls: IKeyCalls = {};
    private static codeCalls: ICodeCalls = {};

    private static handleKeyDown(e: KeyboardEvent) {
        if (GameKeys.keyCalls.all) {
            GameKeys.keyCalls.all(e.key);
        }

        if (GameKeys.keyCalls[e.key]) {
            GameKeys.keyCalls[e.key](e.key);
        }
        if (GameKeys.codeCalls[e.code]) {
            GameKeys.codeCalls[e.code]();
        }

        if (e.key === Keys.SHIFT) {
            GameKeys.isShiftPressed = true;
        }

        if (e.code === KeyCodes.SPACE) {
            GameKeys.isSpacePressed = true;
        }

        e = null;
    }

    private static handleKeyUp(e: KeyboardEvent) {
        if (e.key === Keys.SHIFT) {
            GameKeys.isShiftPressed = false;
        }

        if (e.code === KeyCodes.SPACE) {
            GameKeys.isSpacePressed = false;
        }
    }
}
